
export const LOGIN_ENDPOINT = '/login';
export const ALLOT_ORDER = '/bulkSO';
export const RETURN_ORDER = '/ReturnOrder_CHEP';
export const RECOVER_PASS = '/recoverPassword';
export const GET_AGREEMENT = '/agreement';
export const CUSTOMER_MASTER = '/customer';
export const CHANGE_PASSWORD = '/changePassword';
export const DAMAGE_RR = '/CreateDSRR_CHEP';
export const DAMAGE_SO = '/createDSSO';
export const RECENT_DEHIRE_ORDERS = '/fetch_recentOD';
export const FETCH_REPORT = '/dehire_reports';
export const ALLOT_ORDER_AUTO = '/BulkSO_Auto';
export const FETCH_SKUS = "/fetch_skus";
export const POST_TRIN = "/post_docs";
export const POST_TROUT = "/transout";
export const GET_BASE_DOCUMENT = "/Get_BaseDoc";
export const GET_LOOSE_SKUS = "/loose_skus";
export const GET_ATM_STOCKS = "/ATMStock";
export const GET_FLOW_CUSTOMER = "/GetFlow_ToCustomers";
export const GET_ITEMS_DETAILS = "/Get_ItemDetails";
export const MIS_REPORT = "/Customer_MISReports";
export const GET_ORDER_STATUS = "/Get_OrderStatus";
export const GET_LAYOUT_PURCHASE = "/Fetch_PurchaseOrderlyt";
export const GET_STOCK_POSTING_REPORT = "/stockPosting";
export const GET_CUSTOMER_POOL_BALANCE = "/CustPoolBal";
export const GET_TRANSACTION_LAYOUTS = "/Get_TransactionLyt";
export const GET_ALL_CUSTOMERS_LIST = "/customer_details";
export const GET_ATM_MOVEMENTS_ORDER = "/AtmMovement";
export const RETREIVE_PASSWORD = "/retrievePassword";
export const CALENDER_VIEW = "/CalendarView";
export const FETCH_ORDER_DETAILS = "/FetchOrderDetails";
export const FETCH_ORDER_STATUS = "/FetchOrderStatus";
export const POST_BULK_TRANSFERSOUT = "/TRANSOUT_CHEP";
export const POST_BULK_TRANSFERSIN = "/Post_TransferIn";
export const REJECT_TROUT = "/TRANSOUT_CANCEL_CHEP";
export const POST_BULK_TRIN = "/Post_TransferIn_DiffQTY";
export const BULK_TROUT_EXCEL = "/bulkTROut";
export const TRADING_SALES_ORDER = "/FetchTradingSKU";
export const POST_TRADING_SALES_ORDER = "/TradingOrder";
export const TRADING_FETCH_KIT = "/TradingSO_Fetch_Kit_Components";
export const UPDATE_SO_ORDERS = "/Update_SO";
export const CONTACT_FORM_CS = "/contact";
export const CHECK_BLACKLIST = "/api/check_blacklist";
export const GET_JOB_PROGRESS = "/jobs";

// Report subscriptions
export const REPORT_SUBSCRIPTIONS = "/report_subscriptions";
export const reportSubscriptionUrl = (id) => `/report_subscriptions/${id}`;

// PDF Download Functionality
export const SEARCH_BILLING_DOCS = "/searchBillings";
export const DOWNLOAD_BILLING_PDF = "/downloadBillingPdf";
export const SEND_BILLING_EMAIL = "/sendBillingEmail";


